import { styled } from "@mui/material";
import { PaypalSolid } from "../icon/paypal.es.js";
import { MuiClassCollection } from "../../../foundations/mui-class-collection.es.js";
import { Button } from "../../button/button.es.js";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
import { Direction } from "../../../foundations/direction.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
import { Action, Text } from "../../../foundations/palette.es.js";
import { Typography } from "../../typography/typography.es.js";
const PAYPAL_BUTTON_BACKGROUND = "#F9A000";
const PAYPAL_TEXT_COLOR = "#253B80";
const ButtonContainer = styled(Button)({
  display: Displaying.flex,
  alignItems: Alignment.center,
  flexDirection: Direction.row,
  background: PAYPAL_BUTTON_BACKGROUND,
  padding: `${Spacing["750"]} ${Spacing["1000"]}`,
  gap: Spacing["250"],
  ":hover": {
    background: PAYPAL_BUTTON_BACKGROUND
  },
  [`&.${MuiClassCollection.disabled}`]: {
    background: Action.disabledBackground,
    "& p": {
      color: Text.disabled
    }
  }
});
const PaypalTypographyContainer = styled(Typography)({
  color: PAYPAL_TEXT_COLOR,
  fontFamily: "Inter",
  fontSize: Spacing["750"],
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: Spacing["1000"],
  letterSpacing: "-0.24px"
});
const PaypalIconContainer = styled(PaypalSolid)({
  width: "4rem"
});
export {
  ButtonContainer,
  PaypalIconContainer,
  PaypalTypographyContainer
};
//# sourceMappingURL=container.es.js.map
